import React, { type ButtonHTMLAttributes } from 'react';

import { motion } from 'framer-motion';

import { ReactComponent as ETH } from '@pkg/assets/images/artifacts/nft.svg';

import './MintButton.scss';

const copyTransition = {
    damping: 60,
    stiffness: 15,
    mass: 2,
};
const buttonTransition = {
    damping: 80,
    delay: 0,
    mass: 5,
    delayChildren: 0.2,
};

const button = {
    onHoverDisabled: {
        ...buttonTransition,
        width: 290,
    },
};
const text = {
    onHoverDisabled: {
        ...copyTransition,
        width: 0,
        y: -50,
    },
};

interface ExpandingButtonProps {
    // todo move out?
    copy: string;
    hoverCopy?: string;
    icon?: string;
}
type MintButtonProps = ExpandingButtonProps & ButtonHTMLAttributes<HTMLButtonElement>;

export function MintButton({ copy, disabled, onClick }: MintButtonProps) {
    const base = `yat-mint-button`;
    return (
        <motion.button
            className={`${base}`}
            disabled={disabled}
            initial={{ width: 220 }}
            onClick={onClick}
            whileHover={'onHover'}
            variants={button}
            layout
        >
            <motion.div
                variants={text}
                initial={{ y: 0, width: 'auto' }}
                className={`${base}__copy ${base}__copy-opacity`}
                layout
            >
                <ETH className={`${base}__icon`} />
                <span>{copy}</span>
            </motion.div>
        </motion.button>
    );
}
